import { Navigate, useLocation } from 'react-router-dom';
import { useBrandAuth } from '../../hooks/useBrandAuth';
import { BrandLoadingScreen } from '../brand/BrandLoadingScreen';
import { SubscriptionGuard } from './SubscriptionGuard';

interface BrandProtectedRouteProps {
  children: React.ReactNode;
}

export const BrandProtectedRoute = ({ children }: BrandProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useBrandAuth();
  const location = useLocation();

  if (isLoading) {
    return <BrandLoadingScreen />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate to="/auth/login" state={{ from: location }} replace />
    );
  }

  return <SubscriptionGuard>{children}</SubscriptionGuard>;
};
